import type { ReactNode } from 'react';

import {
  CopyIcon,
  EmailIcon,
  FacebookIcon,
  InstagramIcon,
  SmsIcon,
  XIcon
} from './icons';

export type ShareLinksMethod = 'share' | 'sms' | 'email' | 'copy';

export type SharePlatformId =
  | 'twitter'
  | 'facebook'
  | 'instagram'
  | 'copy'
  | 'email'
  | 'sms';

export type SharePlatform = {
  id: SharePlatformId;
  label: string;
  method: ShareLinksMethod;
  icon: ReactNode;
};

export const getPlatforms = (
  isSocialMediaShareable: boolean,
  onlyCopy: boolean
): SharePlatform[] => {
  if (isSocialMediaShareable) {
    return [
      {
        id: 'twitter',
        label: 'X',
        method: 'share',
        icon: <XIcon />
      },
      {
        id: 'facebook',
        label: 'Facebook',
        method: 'share',
        icon: <FacebookIcon />
      },
      {
        id: 'instagram',
        label: 'Instagram',
        method: 'share',
        icon: <InstagramIcon />
      }
    ];
  }

  if (onlyCopy) {
    return [
      {
        id: 'copy',
        label: 'Copy link',
        method: 'copy',
        icon: <CopyIcon />
      }
    ];
  }

  return [
    {
      id: 'copy',
      label: 'Copy link',
      method: 'copy',
      icon: <CopyIcon />
    },
    {
      id: 'email',
      label: 'Email',
      method: 'email',
      icon: <EmailIcon />
    },
    {
      id: 'sms',
      label: 'SMS',
      method: 'sms',
      icon: <SmsIcon />
    }
  ];
};
